import { useDeviceType } from '@cian/ui-kit';
import { Steps } from 'shared/components/Steps';
import { ArticleContainer } from 'shared/containers/Article';
import type { TRenderedStep, TStep } from 'shared/types/carousel';

interface IStepsContainerProps {
  steps: TStep[];
}

export const StepsContainer: React.FC<IStepsContainerProps> = ({ steps }) => {
  const device = useDeviceType();

  const renderedSteps: TRenderedStep[] = steps.map(({ id, title, slides, banner }) => ({
    id,
    title,
    banner,
    slidesCount: slides.length,
    slides: slides.map((slide, index) => <ArticleContainer key={`${slide.url}-${index}`} {...slide} />),
  }));

  return <Steps device={device} steps={renderedSteps} />;
};
